export default __webpack_public_path__ + "static/media/thumb-Nacic-Clock-1.e2eaece7.png";